var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visibleBanner)?_c('aside',{staticClass:"pw-spot",class:_vm.spotClasses,attrs:{"aria-label":"Współpraca"}},[_c('div',{ref:"bannerContent",staticClass:"pw-spot__html",domProps:{"innerHTML":_vm._s(_vm.visibleBanner.html)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }